import { render } from "./book.vue?vue&type=template&id=24ff4e9b&scoped=true"
import script from "./book.vue?vue&type=script&lang=js"
export * from "./book.vue?vue&type=script&lang=js"

import "./book.vue?vue&type=style&index=0&id=24ff4e9b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24ff4e9b"]])

export default __exports__